import { Link } from "react-router-dom";
import { trackSeoPageEvent, SEO_ANALYTICS_EVENTS } from "../../../constants/seoAnalyticsConstants";

export default function SeoDealerSection({ city, citySlug }) {
  if (!city) return null;

  return (
    <section className="seo-dealers" aria-labelledby="seo-dealers-heading">
      <h2 id="seo-dealers-heading">Concesionarios en {city}</h2>
      <p>Explora perfiles con inventario activo y contacto directo por WhatsApp.</p>
      <Link
        to={`/concesionarios/${citySlug}`}
        className="seo-btn seo-btn--secondary"
        onClick={() => trackSeoPageEvent(SEO_ANALYTICS_EVENTS.DEALER_CLICKED, { citySlug })}
      >
        Ver concesionarios en {city}
      </Link>
      <Link
        to="/v/automap/concesionarios"
        className="seo-dealers__directory"
        onClick={() => trackSeoPageEvent(SEO_ANALYTICS_EVENTS.DEALER_CLICKED, { source: "directory" })}
      >
        Directorio nacional →
      </Link>
    </section>
  );
}
